import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { OxidationReductionPotentialSensorNodeModel } from './OxidationReductionPotentialSensorNodeModel';
import { OxidationReductionPotentialSensorNodeWidget } from './OxidationReductionPotentialSensorNodeWidget';

export class OxidationReductionPotentialSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.OxidationReductionPotentialSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new OxidationReductionPotentialSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <OxidationReductionPotentialSensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        renderedOnMap
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget
        entity={event.model.getEntity()}
        onDevices={event.model.getOnDevices()}
        minimizableModals={this.isMainMap}
      >
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
